import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Gift, MapPin, Tag, ArrowRight } from "lucide-react";

export default function ClubLanding() {
  const { code } = useParams();
  const [club, setClub] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/clubs/by-code/${code}`).then((r) => setClub(r.data)).catch(() => setClub(false)).finally(() => setLoading(false));
  }, [code]);

  if (loading) return <div className="p-16 text-center text-slate-500"><Loader2 className="animate-spin inline" size={20}/> Chargement…</div>;
  if (!club) return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center">
      <h1 className="font-heading text-2xl font-bold text-slate-900">Lien introuvable</h1>
      <p className="mt-2 text-slate-500">Ce club ou cette page n'existe pas (ou n'est plus active).</p>
      <Link to="/bons-plans" className="mt-4 inline-block text-[#E05638] font-semibold">Voir les bons plans →</Link>
    </div>
  );

  return (
    <div data-testid="club-landing-page">
      <div className="bg-gradient-to-br from-[#E05638] to-amber-500 text-white">
        <div className="max-w-3xl mx-auto px-4 py-16 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/20 text-white text-xs font-bold uppercase tracking-widest">
            <Gift size={14}/> Avantage {club.name}
          </div>
          {club.logo && <img src={club.logo} alt={club.name} className="mt-5 h-16 mx-auto object-contain"/>}
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl font-extrabold">Membres de {club.name}, vos bons plans locaux vous attendent</h1>
          <p className="mt-3 text-white/90 max-w-xl mx-auto">
            {club.description || "Profitez gratuitement des réductions et avantages des commerces d'Eure-et-Loir, offerts via votre club."}
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link to={`/inscription?club=${club.code}`}>
              <Button className="bg-white text-[#E05638] hover:bg-white/90 h-12 px-6 font-bold" data-testid="club-cta-register">
                Créer mon compte gratuit <ArrowRight size={16} className="ml-1"/>
              </Button>
            </Link>
            <Link to="/bons-plans">
              <Button variant="outline" className="border-white text-white hover:bg-white/10 h-12 px-6 font-bold" data-testid="club-cta-deals">
                Voir les bons plans
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-12 grid sm:grid-cols-3 gap-4">
        {[
          { I: Tag, t: "100 % gratuit", d: "Aucun frais pour les membres de votre club." },
          { I: MapPin, t: "Près de chez vous", d: "Des commerces partenaires partout en Eure-et-Loir." },
          { I: Gift, t: "Des avantages réels", d: "Réductions et offres exclusives toute l'année." },
        ].map((b, i) => {
          const I = b.I;
          return (
            <div key={i} className="bg-white border border-slate-200 rounded-2xl p-5 text-center">
              <I size={22} className="text-[#E05638] mx-auto"/>
              <div className="mt-2 font-bold text-slate-900">{b.t}</div>
              <div className="mt-1 text-sm text-slate-500">{b.d}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
